import RouteEveryoneListScreen from "./RouteEveryoneListScreen/RouteEveryoneListScreen";

export default function RouteScreen() {
  return <RouteEveryoneListScreen />;
}
